import { useContext } from "react";
import { AuthenticationContext } from "../../context/Authentication/authenticationContext";

export const useUser = () => {
  const { user } = useContext(AuthenticationContext);
  return user;
};
